import "./bootstrap-types";
import { bootstrapApp } from "./app/bootstrap";

document.addEventListener("DOMContentLoaded", bootstrapApp);
